import * as Sentry from '@sentry/browser';
import {getTimestampCorrelationId} from '../canvas-timeline/canvas_timeline_performance_track';
import {fetchDataPromises} from '../scheduling_fetch';
import DirectApi from '../../../directApi';
import {getFetchDates} from '../loading/LoadMoreUtil';
import {useItemsLazyLoading} from '../canvas-timeline/canvas_timeline_util';

export const PEOPLE_SCHEDULE_FETCH_TIMEOUT_MS = 90000;

export const fetchData = (pageComponent, loadAllData) => {
	const req = {method: 'POST'};
	const timestampCorrelationId = getTimestampCorrelationId();

	let requestUrl = DirectApi.graphqlServerEndpoint('scheduling/people/full');
	requestUrl += `?timestampCorrelationId=${timestampCorrelationId}`;
	if (loadAllData) {
		requestUrl += '&loadAllData=true';
	}

	req.url = requestUrl;

	const requestUrls = [req];

	if (useItemsLazyLoading(pageComponent)) {
		req.body = {
			...getFetchDates(pageComponent),
		};
	}

	// fetchDataPromises never rejects, but it has no timeout of its own -- a request that
	// truly never returns leaves it pending forever. Race it against a timeout specific to
	// this view so "a response that never arrives" still reaches the error state, per the
	// People Schedule AC. The loser of the race is not cancelled -- fetchDataPromises owns
	// its own AbortController and nothing outside it calls .abort() -- but since it never
	// rejects either, letting it resolve unobserved is inert, not a leak.
	const timeoutPromise = new Promise(resolve => {
		setTimeout(
			() =>
				resolve([
					{
						error: true,
						status: 0,
						isNoViewer: false,
						isNetworkError: false,
						endpoint: 'scheduling/people/full',
						correlationId: timestampCorrelationId,
						timestampCorrelationId,
						serverMessage: `Timed out after ${PEOPLE_SCHEDULE_FETCH_TIMEOUT_MS}ms`,
					},
				]),
			PEOPLE_SCHEDULE_FETCH_TIMEOUT_MS
		);
	});

	return Promise.race([fetchDataPromises(requestUrls), timeoutPromise]);
};

// fetchDataPromises' shared error sentinel is normally reported to Sentry by the
// MUTATION_ERROR modal it triggers everywhere else in the app. People Schedule renders its
// own retry-in-place state instead of that modal (see SchedulingLoadError), so it reports
// the same diagnostic fields itself rather than losing them.
export const reportLoadFailure = loadError => {
	Sentry.captureException(new Error(`Scheduling data load failed: ${loadError.endpoint}`), {
		level: 'error',
		extra: {
			endpoint: loadError.endpoint,
			status: loadError.status,
			correlationId: loadError.correlationId,
			isNetworkError: loadError.isNetworkError,
			serverMessage: loadError.serverMessage,
		},
	});
};
